"use strict";

import $ from "jquery";

export function initInScope ($scope) {
    // console.log("login modal test");

    let summaryForm = $(".js-submit-res"); //only for summary
    let modal = $scope.find("#loginOrRegModal");
    let loadingOverlay = modal.find(".loading-overlay");
    $(".login-btn").on("click", function (e) {
        e.preventDefault();
        // console.log("loginbtn clicked");
        modal.modal('show');
        return false;
    });



    //overrides some buttons to login
    let openMessageModalAfterLogin = false;
    let redirectOverride = null;
    $(".cta-link").on("click", function (e) {
        e.preventDefault();
        // console.log("cta link clicked clicked");
        openMessageModalAfterLogin = true;
        modal.modal('show');
        return false;
    });
    $(".watchList-link").on('click', function (e) {
        e.preventDefault();
        redirectOverride = $(this).attr("href");
        modal.modal('show');
        return false;
    });

    let ssoAuthBtn = $scope.find('.js-btn-ssoauth');
    ssoAuthBtn.on('click', function (e) {
        e.preventDefault();
        // console.log("clicked on ssoath btn")
        const btn = $(this);
        loadingOverlay.show();
        setInitRegData(function() {
            // console.log
            // let w = Math.min(600, window.innerWidth);
            // let h = Math.min(400, window.innerHeight);
            let popup = window.open(
                btn.attr('href'),
                'google-oauth',
                `width=600,height=350`
            );
            // let popup = window.open(btn.attr('href'), 'google-oauth', 'width=500,height=375');
            const popupChecker = setInterval(function() {
                if (popup.closed) {
                    clearInterval(popupChecker);
                    loadingOverlay.hide();
                }
            }, 500);
        });
        return false;
    });

    window.addEventListener('message', function(e) {
        loadingOverlay.hide();
        if (e.data.oauthSuccess) {
            // console.log("reloading");
            reloadPage(e.data, e.data.registered === true);
        }
    });


    let loginForm = modal.find("form:first");
    let inSummary = loginForm.data("in-summary") === 1;
    let landlordPreselected = loginForm.data("landlord-preselected") === 1;
    let registerSendToUrl = loginForm.find('input[name="init-register-send-to-url"]').val() === 1;
    let pwField = loginForm.find(".pw");
    let pwInput = pwField.find('input[name="_password"]');
    let emailInput = loginForm.find('input[name="_username"]');
    let checkInterval = null;
    let waitForConfirmEl = modal.find('.wait-for-confirm');

    modal.on("show.bs.modal", function(e) {
        // console.log("showing login modal");
        setLoginMode("init");
    });

    // TODO do this until the hash router is inculded everywhere
    modal.on('hide.bs.modal', function (e) {
        if (window.location.hash === '#login') {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    });
    modal.find('.form-group').on('click', function() {
        $(this).find("input").focus();
    });

    modal.find('.js-password-toggle').on('click', function() {
        var passwordField = loginForm.find('#_password');

        if (passwordField.attr('type') === 'password') {
            passwordField.attr('type', 'text');
            $(this).removeClass('icon-aktiviert').addClass('icon-deaktiviert');
        } else {
            passwordField.attr('type', 'password');
            $(this).removeClass('icon-deaktiviert').addClass('icon-aktiviert');
        }
    });
    let allowLandlordReg = modal.data("allow-landlord-reg") === 1;
    let registerMode = "renter";
    let modalMode = "login";
    let registerModeEl = modal.find('.register-mode');

    emailInput.on('keydown', function(e) {
        if (modalMode !== 'login') return;
        if (e.key === 'Enter') return;

        if (
            (typeof e.key === 'string' && e.key.length === 1) ||
            e.key === 'Backspace' ||
            e.key === 'Delete'
        ) {
            pwInput.val('');
        }
    });

    emailInput.on('paste', function() {
        if (modalMode !== 'login') return;
        pwInput.val('');
    });

    registerModeEl.find('.rmc').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('register-renter')) {
            loginForm.attr("action", "/404");
            registerMode = "renter";
        } else if($(this).hasClass('register-landlord')) {
            // console.log("changing action to " + $(this).data("action"));
            loginForm.attr("action", $(this).data("action"));
            registerMode = "landlord"
        }
        registerModeEl.find('.rmc').removeClass('active');
        $(this).addClass('active');
        return false;
    });

    loginForm.on("submit", function (e) {
        e.preventDefault();

        if (!$(this).parsley().validate()) {
            // console.log("parsley not valid");
            return false;
        }

        // console.log("submit login");
        let email = $(this).find("#_username").val();
        let pw = $(this).find("#_password").val();

        let hasPw = pw.length > 0;
        if(modalMode == "registration" && registerMode == "landlord") {
            this.submit();
        } else {
            checkIfValid($(this), modal);
        }


        return false;
    });

    function setInitRegData(regDataCallback) {
        let sessionUrl = loginForm.data('api-session-data');
        let registerUrl = window.location.href.split('#')[0];
        let registerAcco = '';
        if(inSummary) {
            registerAcco = summaryForm.data('acco-url');
        }
        $.post(sessionUrl, {
            'init-register-url': registerUrl,
            'init-register-acco': registerAcco,
            'init-register-send-to-url': registerSendToUrl
        }).always(function() {
            regDataCallback();
        });
    }

    function setLoginMode(mode) {
        if(mode == "init") {
            pwField.find(".form-errors").html("");
            modal.find('.login-reg-container').show();
            modal.find('.wait-info').html('');
            modal.find('.wait-for-confirm').hide();
            pwField.hide();
            modal.find('.show-for-reg').hide();
            modal.find('.hide-for-reg').show();
            modal.find('input[name="isRegister"]').val(0);
            // modal.find('form').attr("action", modal.find('form').data("api-login"));
            modal.find('form').data("action", modal.find('form').data("api-login"));
            modal.find('.register-mode').hide();
            modal.find(".login-span").hide();
            modal.find(".weiter-span").show();
            modal.find(".show-for-pw").hide();
            modal.find(".hide-for-pw").show();
            pwInput.attr('placeholder', pwInput.data("placeholder-login"))
            modal.find('.modal-title').html(loginForm.data('trans-title-loginreg'));
            disableRegisterPasswordValidation();
        } else if(mode == "showpw") {
            pwField.find(".form-errors").html("");
            pwField.show();
            modal.find(".login-span").show();
            modal.find(".weiter-span").hide();
            modal.find(".show-for-pw").show();
            modal.find(".hide-for-pw").hide();
            pwInput.attr('placeholder', pwInput.data("placeholder-login"))
            modal.find('.modal-title').html(loginForm.data('trans-title-loginreg'));
            disableRegisterPasswordValidation();
        } else if(mode == "reg") {
            pwField.find(".form-errors").html("");
            modal.find('.show-for-reg').show();
            modal.find('.hide-for-reg').hide();
            modal.find(".show-for-pw").hide();
            modal.find('input[name="isRegister"]').val(1);
            if(allowLandlordReg) {
                modal.find('.register-mode').show();
            }
            // modal.find('form').attr("action", modal.find('form').data("api-register"));
            modal.find('form').data("action", modal.find('form').data("api-register"));
            pwInput.attr('placeholder', pwInput.data("placeholder-reg"))
            pwField.show();
            modal.find('.modal-title').html(loginForm.data('trans-title-loginreg'));
            enableRegisterPasswordValidation();
            if(landlordPreselected) {
                modal.find('.rmc.register-landlord a').trigger('click');
            }

            if(inSummary) {
                modal.find('.js-consent-container').hide();
            } else {
                modal.find('.js-consent-container').show();
            }
        }
    }

    function waitForConfirm(response) {
        if(checkInterval !== null) {
            clearInterval(checkInterval);
        }
        checkInterval = null;
        // console.log("waiting for confirm");
        modal.find('.login-reg-container').hide();

        let waitInfos = modal.find('.wait-info');
        // let confirmedThx = modal.find('.confirmed-thx');
        waitForConfirmEl.show();
        waitInfos.html(response.html);

        let sendAgainButton = waitForConfirmEl.find('.js-send-again');
        let manualCheckButton = waitForConfirmEl.find('.js-check-manual');
        let sendAgainUrl = waitForConfirmEl.data("send-again-url");
        let checkUrl = waitForConfirmEl.data("check-url");
        let initInfos = waitForConfirmEl.find('.js-init-infos');
        let sentAgain = modal.find('.sent-again');
        modal.find('.modal-title').html(loginForm.data('trans-title-code'));
        initConfirmSnippet(waitForConfirmEl);

        // function doCheck() {
        //     $.ajax(checkUrl, {
        //         type: 'POST',
        //         headers: {
        //             'X-Requested-With': 'XMLHttpRequest'
        //         },
        //         data: {
        //             'userid': initInfos.data("userid")
        //         },
        //         dataType: 'JSON'
        //     }).then(response => {
        //         if (response && response.confirmed && response.loggedIn) {
        //             clearInterval(checkInterval);
        //             waitInfos.hide();
        //             confirmedThx.show();
        //             window.location.reload();
        //         }
        //     }).catch((...params) => {
        //         console.error(...params);
        //     }).always(function () {
        //         loadingOverlay.hide();
        //     });
        // }

        //checkInterval = setInterval(doCheck, 5000);

        sendAgainButton.on('click', function (e) {
            e.preventDefault();
            loadingOverlay.show();
            $.ajax(sendAgainUrl, {
                type: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: {
                    'mieter': initInfos.data('userid'),
                    'typ': 'mieter'
                },
                dataType: 'JSON'
            }).then(response => {
                // console.log(response);
                sentAgain.show();
                sendAgainButton.hide();
            }).catch((...params) => {
                console.error(...params);
            }).always(function () {
                loadingOverlay.hide();
            });
            return false;
        });

        // manualCheckButton.on('click', function () {
        //     loadingOverlay.show();
        //     doCheck();
        // });
    }

    function reloadPage(response = null, registered = false) {
        if(inSummary) {
            if(summaryForm.length > 0) {
                sessionStorage.setItem('summaryForm', JSON.stringify({
                    aufenthalt: summaryForm.find('#aufenthalt').val(),
                    agb: summaryForm.find('input[name="agb"]').is(':checked'),
                    wiederruf: summaryForm.find('input[name="wiederruf"]').is(':checked')
                }));
            }
        }
        if(openMessageModalAfterLogin) {
            sessionStorage.setItem('openMessageModal', "1");
        }

        //tracking
        if(registered) {
            let regType = registerMode == 'landlord' ? 'Vermieter' : 'Mieter';
            if($('.snippet-registermode').length > 0) {
                regType = $('.snippet-registermode').data('registermode');
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'registration',
                'registration_type': regType
            });
        }

        // console.log("reloading and thgis is the redirect path:");
        // console.log(response);
        if(redirectOverride) {
            window.location.href = redirectOverride;
            redirectOverride = null;
        } else if(response && response.redirect) {
            window.location.href = response.redirect;
        } else {
            window.location.reload();
        }
    }

    // const NEEDTOCONFIRM = 1;
    // const BOTTING  = 2;
    // const MISSINGUSERNAME = 3;
    // const MISSINGPW = 4;
    // const NONEXISTINGUSER = 5;
    // const INVALIDCREDS = 6;
    // const PWRECOVERY = 7;
    // const USERINACTIVE = 8;
    // const SSOCONNECTED = 9;
    function checkIfValid(form, modal) {
        let errorBlock = modal.find('.error-block');
        let errorMsg = errorBlock.find('.error-msg')
        let loginUrl = form.data("action");
        //update init-register-url input so we have the right params when redirecting after sessionless code entry
        loginForm.find('input[name="init-register-url"]').val(window.location.href.split('#')[0]);
        errorBlock.hide();
        errorMsg.html("");
        loadingOverlay.show();
        $.ajax(loginUrl, {
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: form.serialize(),
            dataType: 'JSON'
        }).then(response => {
            // console.log(response);
            if (response && response.success) {
                reloadPage(response);
            } else if (response && response.regSuccess) {
                //reg successful.
                waitForConfirm(response)
            } else if (response && !response.success) {
                let omiterrors = false;
                if(response.errorCode === 4) {
                    // console.log("show pw field");
                    setLoginMode("showpw");
                } else if(response.errorCode === 6) {
                    // console.log("show pw field invalid creds");
                    setLoginMode("showpw");
                } else if(response.errorCode === 9) {
                    // console.log("ssoConnected");
                    // omiterrors = true;
                    setLoginMode("ssoConnected", );
                } else if(response.errorCode === 5) {
                    // console.log("going to reg");
                    modalMode = "registration";
                    setLoginMode("reg");
                } else if(response.errorCode === 1) {
                    // setLoginMode("reg");
                    // checkIfValid(form, modal);
                    fetchConfirmSnippet(response);
                }
                if(response.errors.length > 0 && !omiterrors) {
                    errorBlock.show();
                    errorMsg.html(response.errors[0])
                }
            }
        }).catch((...params) => {
            console.error(...params);
        }).always(function () {
            loadingOverlay.hide();
        });
    }

    function fetchConfirmSnippet(response) {
        loadingOverlay.show();
        let uri = waitForConfirmEl.data('snippet-url');
        $.ajax(uri, {
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: {'userid': response.userid },
            dataType: 'JSON'
        }).then(response => {
            // console.log(response);
            if (response && response.success) {
                waitForConfirm(response);
            }
        }).catch((...params) => {
            console.error(...params);
        }).always(function () {
            loadingOverlay.hide();
        });
    }

    function submitConfirmCode(userid, code) {
        // console.log("auto submitting", code);
        // console.log("with userid", userid);
        let errorBlock = $(".wait-for-confirm .alert-danger");
        errorBlock.html("");
        errorBlock.hide();
        loadingOverlay.show();
        let uri = waitForConfirmEl.data('submit-url');
        $.ajax(uri, {
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            data: {'userid': userid, 'code': code },
            dataType: 'JSON'
        }).then(response => {
            // console.log(response);
            if (response && response.success) {
                reloadPage(response, true);
            } else {
                if(response.errors.length > 0) {
                    errorBlock.html(response.errors[0]);
                    errorBlock.show();
                }
                if(response.expired) {
                    modal.find('.verification-code input').val('');
                }
            }
        }).catch((...params) => {
            console.error(...params);
        }).always(function () {
            loadingOverlay.hide();
        });
    }

    function initConfirmSnippet($initScope) {
        // Auto-advance on input
        let userid = $initScope.find('.js-init-infos').data('userid');
        let errorBlock = $initScope.find('.alert-danger');
        errorBlock.hide();
        // console.log('userid', userid);
        $initScope.find('.verification-code__input').on('input', function () {
            const val = $(this).val();
            if (val.length === 1 && /[0-9]/.test(val)) {
                const $next = $(this).next('.verification-code__input');
                if ($next.length) {
                    $next.focus();
                } else {
                    // last digit entered — collect and submit
                    const code = $(this).closest('.js-verification-code')
                        .find('.verification-code__input')
                        .map(function () { return $(this).val(); })
                        .get()
                        .join('');

                    if (code.length === 6) {
                        submitConfirmCode(userid, code);
                    }
                }
            }
        });
        $initScope.find('.verification-code__input').on('focus', function () {
            $(this).select();
        });
        // Backspace goes back
        $initScope.find('.verification-code__input').on('keydown', function (e) {
            if (e.key === 'Backspace' && $(this).val() === '') {
                $(this).prev('.verification-code__input').focus();
            }
        });

        // Handle paste of full code
        $initScope.find('.verification-code__input').on('paste', function (e) {
            const pasted = (e.originalEvent.clipboardData || window.clipboardData)
                .getData('text')
                .replace(/\D/g, '')
                .slice(0, 6);

            if (pasted.length === 6) {
                $(this).closest('.js-verification-code')
                    .find('.verification-code__input')
                    .each(function (i) {
                        $(this).val(pasted[i] || '');
                    });
                submitConfirmCode(userid, pasted);
            }
        });

        // Collect code on submit
        $initScope.find('.js-submit-code').on('click', function (e) {
            e.preventDefault();
            const $inputs = $initScope.find('.verification-code__input');
            const code = $inputs
                .map(function () { return $(this).val(); })
                .get()
                .join('');

            // console.log(code, code.length);
            if (code.length < 6) {
                // console.log("not 6 digits");
                return;
            }
            submitConfirmCode(userid, code);
            return false;
        });
    }

    function enableRegisterPasswordValidation() {
        pwInput
            .attr("data-parsley-pattern", "^(?=.*\\d).{8,}$")
            .attr(
                "data-parsley-pattern-message",
                pwInput.data('trans-pw-error')
            );

        resetParsleyIfAvailable();
    }

    function disableRegisterPasswordValidation() {
        pwInput
            .removeAttr("data-parsley-pattern")
            .removeAttr("data-parsley-pattern-message");

        resetParsleyIfAvailable();
    }

    function resetParsleyIfAvailable() {
        if (typeof $.fn.parsley === "function") {
            loginForm.parsley().reset();
        }
    }

    if (window.location.hash === '#login') {
        modal.modal('show');
    }
}



